import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { tokens, Text } from '@hotjar/hotsauce';

const Title = styled(Text)`
  padding-top: ${tokens.spacer.x3};
`;

export const EnterUrlMessage = (): JSX.Element => {
  const { t } = useTranslation('heatmaps');
  return (
    <>
      <svg
        width="29"
        height="28"
        viewBox="0 0 29 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 2.11321C7.93511 2.11321 2.61321 7.43511 2.61321 14C2.61321 20.5649 7.93511 25.8868 14.5 25.8868C21.0649 25.8868 26.3868 20.5649 26.3868 14C26.3868 7.43511 21.0649 2.11321 14.5 2.11321ZM0.5 14C0.5 6.26801 6.76801 0 14.5 0C22.232 0 28.5 6.26801 28.5 14C28.5 21.732 22.232 28 14.5 28C6.76801 28 0.5 21.732 0.5 14ZM14.5 12.9434C15.0835 12.9434 15.5566 13.4165 15.5566 14V20.9695C15.5566 21.5531 15.0835 22.0261 14.5 22.0261C13.9165 22.0261 13.4434 21.5531 13.4434 20.9695V14C13.4434 13.4165 13.9165 12.9434 14.5 12.9434ZM14.5607 9.02188C14.5607 9.05554 14.5335 9.08283 14.4998 9.08283C14.4661 9.08283 14.4388 9.05554 14.4388 9.02188C14.4388 8.98821 14.4661 8.96092 14.4998 8.96092C14.5335 8.96092 14.5607 8.98821 14.5607 9.02188ZM14.4998 6.96963C13.3664 6.96963 12.4475 7.88845 12.4475 9.02188C12.4475 10.1553 13.3664 11.0741 14.4998 11.0741C15.6332 11.0741 16.552 10.1553 16.552 9.02188C16.552 7.88845 15.6332 6.96963 14.4998 6.96963Z"
          fill="black"
          fillOpacity="0.43"
        />
      </svg>
      <Title as="h5" textType="header5">
        {t('empty-state.enter-url-message')}
      </Title>
    </>
  );
};
